module.exports = __webpack_public_path__ + "img/warning.96e0aaa3.svg";